import planbusiness from '../../../images/plan-business.png';
import planbusinessmax from '../../../images/plan-business-max.png';
import planstarter from '../../../images/plan-starter.png';

// Estructura optimizada: una sola fuente de datos
export const PLANS = [
  {
    id: "starter",
    icon: planstarter,
    plan: "Starter",
    pricing: {
      monthly: "S/. 0.00",
      yearly: "S/. 0.00"
    },
    description: "Pensada para micro restaurantes",
    alert: "sin comprobantes",
    features: [
      "Proveedores, Almacenes y Suministros",
      "Categorías y Productos",
      "Conexión con impresoras portátiles",
      "Reporte de ventas, utilidades, comensales",
      "Soporte remoto",
      "2 cuentas de empleados",
      "5 GB almacenamiento",
    ],
  },
  {
    id: "business",
    icon: planbusiness,
    plan: "Business",
    pricing: {
      monthly: "S/. 49.00",
      yearly: "S/. 490.00"
    },
    description: "Pensada para micro restaurantes",
    alert: "sin comprobantes",
    features: [
      "Proveedores, Almacenes y Suministros",
      "Categorías y Productos",
      "Conexión con impresoras portátiles",
      "Reporte de ventas, utilidades, comensales",
      "Prioridad de soporte remoto",
      "5 cuentas de empleados",
      "10 GB almacenamiento",
      "Conexión con Kusina Delivery",
    ],
  },
  {
    id: "business_max",
    icon: planbusinessmax,
    plan: "Business Max",
    pricing: {
      monthly: "S/. 99.00",
      yearly: "S/. 990.00"
    },
    description: "Pensada para pequeños restaurantes",
    alert: "comprobantes ilimitados",
    comingSoon: true,
    footnotes: {
      "1": "Actualmente órdenes de Rappi y PedidosYa"
    },
    features: [
      "Proveedores, Almacenes y Suministros",
      "Categorías y Productos",
      "Conexión con impresoras portátiles",
      "Reporte y Estadísticas de ventas, utilidades, comensales",
      "Prioridad de soporte remoto",
      "10 cuentas de empleados",
      "Almacenamiento flexible",
      "Conexión con Kusina Delivery",
      "Conexión con ordenes de apps de delivery¹",
      "Boletas y facturas electrónicas ilimitadas",
    ],
  },
];

// Mantener exports antiguos para compatibilidad (deprecated)
export const MONTHLY_PLAN = PLANS;
export const YEARLY_PLAN = PLANS;
